module.exports = __webpack_public_path__ + "media/images/icons/vendors/transport-7e979ca72e700bac4c021a6d314e038c.png";